import { get } from "lodash";

//TODO: Refer these constants from "create-property/definitions" once that file is pushed to mainline
export const propertyQualityTypes = [
    { label: "Low", value: "Low" },
    { label: "Cheap", value: "Cheap" },
    { label: "Average", value: "Average" },
    { label: "Fair", value: "Fair" },
    { label: "Good", value: "Good" },
    { label: "Excellent", value: "Excellent" },
];

export const propertyClassTypes = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
    { value: "D", label: "D" },
    { value: "S", label: "S" },
];

export const climateOptions = [
    { label: "Moderate", value: "Moderate" },
    { label: "Extreme", value: "Extreme" },
];

export const regionOptions = [
    { label: "Western", value: "Western" },
    { label: "Eastern", value: "Eastern" },
    { label: "Central", value: "Central" },
];

export const generateKeyValuePair = (data: any, key: string) => {
    if (key === "") return { key: "", value: "" };

    return { key: key, value: get(data, key, "") };
};

export const summaryMapping = (data: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.summary`;

    return [
        {
            title: "Total summary of all sections",
            options: [
                {
                    header: "Replacement cost",
                    type: "text",
                    prefix: "$",
                    editable: false,
                    ...generateKeyValuePair(data, `${keyPrefix}.totalReplacementCost`),
                },
                {
                    header: "Additional Features/Site improvements",
                    prefix: "$",
                    type: "text",
                    editable: false,
                    ...generateKeyValuePair(
                        data,
                        `${keyPrefix}.additionalFeaturesSiteImprovements`
                    ),
                },
                {
                    header: "Land value",
                    prefix: "$",
                    type: "inputNumber",
                    editable: true,
                    ...generateKeyValuePair(data, `${keyPrefix}.landValue`),
                },
            ],
        },
        {
            title: "Ignore",
            options: [
                {
                    header: "Adj depreciated cost",
                    headerType: "h100",
                    valueType: "h100",
                    type: "text",
                    prefix: "$",
                    editable: false,
                    ...generateKeyValuePair(data, `${keyPrefix}.adjustedDepreciatedCost`),
                },
                {
                    header: "Improvement value",
                    prefix: "$",
                    type: "text",
                    editable: false,
                    ...generateKeyValuePair(data, `${keyPrefix}.improvementValue`),
                },
                {
                    header: "Final value",
                    headerType: "h100",
                    valueType: "h100",
                    prefix: "$",
                    type: "text",
                    editable: false,
                    ...generateKeyValuePair(data, `${keyPrefix}.finalValue`),
                },
            ],
        },
    ];
};

// NOTE: Below table mappings are named as per the order of visibility in the UI.
export const costSpaceTableOneMapping = (data: any, spaceId: string) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.spaceComputationData.${spaceId}`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Occupancy",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, `${keyPrefix}.occupancy`),
                },
                {
                    header: "Construction/Building class",
                    editable: true,
                    type: "dropdown",
                    options: [...propertyClassTypes],
                    ...generateKeyValuePair(data, `${keyPrefix}.constructionBuildingClass`),
                },
                {
                    header: "Construction/Building quality",
                    editable: true,
                    type: "dropdown",
                    options: [...propertyQualityTypes],
                    ...generateKeyValuePair(data, `${keyPrefix}.constructionBuildingQuality`),
                },
                {
                    header: "No of story",
                    editable: true,
                    type: "inputNumber",
                    ...generateKeyValuePair(data, `${keyPrefix}.noOfStories`),
                },
                {
                    header: "Height per story",
                    suffix: "ft",
                    editable: true,
                    type: "inputNumber",
                    ...generateKeyValuePair(data, `${keyPrefix}.heightPerStory`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, ``),
                },
                {
                    header: "Average floor area (sqft)",
                    editable: false,
                    ...generateKeyValuePair(data, `${keyPrefix}.averageFloorAreaSqFt`),
                },
                {
                    header: "Age",
                    editable: true,
                    type: "inputNumber",
                    ...generateKeyValuePair(data, `${keyPrefix}.age`),
                },
                {
                    header: "Region",
                    editable: true,
                    type: "dropdown",
                    options: [...regionOptions],
                    ...generateKeyValuePair(data, `${keyPrefix}.region`),
                },
                {
                    header: "Climate",
                    editable: true,
                    type: "dropdown",
                    options: [...climateOptions],
                    ...generateKeyValuePair(data, `${keyPrefix}.climate`),
                },
                {
                    header: "Base square foot cost",
                    headerType: "h100",
                    valueType: "h100",
                    prefix: "$",
                    editable: false,
                    type: "text",
                    imageKey: `${keyPrefix}.baseSquareFootCostS3Object`,
                    ...generateKeyValuePair(data, `${keyPrefix}.baseSqFtCost`),
                },
            ],
        },
    ];
};

export const costSpaceTableTwoMapping = (data: any, spaceId: string) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.spaceComputationData.${spaceId}.heightAndSizeRefinement`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Clear Height per story - multiplier",
                    editable: false,
                    type: "text",
                    imageKey: `${keyPrefix}.clearHeightPerStoryMultiplierS3Object`,
                    ...generateKeyValuePair(data, `${keyPrefix}.clearHeightPerStoryMultiplier`),
                },
                {
                    header: "Floor area/perimeter - multiplier",
                    editable: false,
                    type: "text",
                    imageKey: `${keyPrefix}.floorAreaPerimeterMultiplierS3Object`,
                    ...generateKeyValuePair(data, `${keyPrefix}.floorAreaPerimeterMultiplier`),
                },
                {
                    header: "Combined height and size multiplier",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, `${keyPrefix}.combinedHeightAndSizeMultiplier`),
                },
                {
                    header: "Adjusted rate",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.adjustedRate`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Current cost multiplier",
                    editable: false,
                    type: "text",
                    imageKey: `${keyPrefix}.currentCostMultiplierS3Object`,
                    ...generateKeyValuePair(data, `${keyPrefix}.currentCostMultiplier`),
                },
                {
                    header: "Local multiplier",
                    editable: false,
                    type: "text",
                    imageKey: `${keyPrefix}.localMultiplierS3Object`,
                    ...generateKeyValuePair(data, `${keyPrefix}.localMultiplier`),
                },
                {
                    header: "Combined multiplier",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, `${keyPrefix}.combinedMultiplier`),
                },
                {
                    header: "Final square foot cost",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.finalSqFtCost`),
                },
                {
                    header: "Area",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, `${keyPrefix}.area`),
                },
                {
                    header: "Replacement cost",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.replacementCost`),
                },
            ],
        },
    ];
};

export const costSpaceTableThreeMapping = (data: any, spaceId: string) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.spaceComputationData.${spaceId}`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Effective Physical Depreciation % (Section 97)",
                    editable: false,
                    type: "text",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.effectivePhysicalDepreciation`),
                },
                {
                    header: "Additional Functional Depreciation",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.additionalFunctionalDepreciation`),
                },
                {
                    header: "Additional Economic Obsolescence",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.additionalEconomicObsolescence`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Effective Physical Depreciation Amount",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(
                        data,
                        `${keyPrefix}.effectivePhysicalDepreciationAmount`
                    ),
                },
                {
                    header: "Functional Depreciation Amount",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.functionalDepreciationAmount`),
                },
                {
                    header: "Economic Obsolescence Amount",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.economicObsolescenceAmount`),
                },
                {
                    header: "Total depreciation",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.totalDepreciation`),
                },
                {
                    header: "Adjusted depreciated cost",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.adjustedDepreciatedCost`),
                },
            ],
        },
    ];
};

export const costFeatureTableOneMapping = (data: any, featureId: string, featureType: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.featuresComputationData.features.${featureId}`;

    return [
        {
            title: "",
            options: [
                {
                    header: `${featureType} base rate`,
                    editable: false,
                    type: "text",
                    prefix: "$",
                    imageKey: `${keyPrefix}.baseRateS3Object`,
                    ...generateKeyValuePair(data, `${keyPrefix}.baseRate`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: `${featureType} adjusted rate`,
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.adjustedRate`),
                },
                {
                    header: `${featureType} area (sqft)`,
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.areaSqFt`),
                },
                {
                    header: `${featureType} cost`,
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.cost`),
                },
            ],
        },
    ];
};

export const costFeatureTableTwoMapping = (data: any, featureId: string, featureType: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.featuresComputationData.features.${featureId}`;

    return [
        {
            title: "",
            options: [
                {
                    header: `Number of ${featureType}`,
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, `${keyPrefix}.number`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: `${featureType} base rate`,
                    editable: false,
                    type: "text",
                    prefix: "$",
                    imageKey: `${keyPrefix}.baseRateS3Object`,
                    ...generateKeyValuePair(data, `${keyPrefix}.baseRate`),
                },
                {
                    header: `${featureType} cost`,
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.cost`),
                },
            ],
        },
    ];
};

export const costFeatureTableThreeMapping = (data: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.featuresComputationData.summary`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Other (See Lump Sum Addenda)",
                    editable: true,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.other`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Miscellaneous",
                    editable: true,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.miscellaneous`),
                },
                {
                    header: "Replacement cost of features",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.replacementCostOfFeatures`),
                },
            ],
        },
    ];
};

export const costFeatureTableFourMapping = (data: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.featuresComputationData.summary`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Physical depreciation %",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.physicalDepreciation`),
                },
                {
                    header: "Functional depreciation %",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.functionalDepreciation`),
                },
                {
                    header: "Economic obsolescence %",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.economicObsolescence`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Physical depreciation amount",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.physicalDepreciationAmount`),
                },
                {
                    header: "Functional depreciation amount",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.functionalDepreciationAmount`),
                },
                {
                    header: "Economic obsolescence amount",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.economicObsolescenceAmount`),
                },
                {
                    header: "Total depreciation",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.totalDepreciation`),
                },
                {
                    header: "Adjusted depreciation cost",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.adjustedDepreciatedCost`),
                },
            ],
        },
    ];
};

export const costSiteImprovementTableOneMapping = (
    data: any,
    siteImprovementId: string,
    siteImprovementType: any
) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.siteImprovementComputationData.siteImprovements.${siteImprovementId}`;

    return [
        {
            title: "",
            options: [
                {
                    header: `${siteImprovementType} per unit`,
                    editable: false,
                    type: "text",
                    prefix: "$",
                    imageKey: `${keyPrefix}.perUnitS3Object`,
                    ...generateKeyValuePair(data, `${keyPrefix}.perUnit`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: `${siteImprovementType} per unit adjusted`,
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.perUnitAdjusted`),
                },
                {
                    header: `${siteImprovementType} area (sqft)`,
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.areaSqFt`),
                },
                {
                    header: `${siteImprovementType} total`,
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.total`),
                },
            ],
        },
    ];
};

export const costSiteImprovementTableTwoMapping = (data: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.siteImprovementComputationData.summary`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Other lump sum for site improvements",
                    editable: true,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.otherLumpSumForSiteImprovements`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Miscellaneous",
                    editable: true,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.miscellaneous`),
                },
                {
                    header: "Total site improvement cost",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.totalSiteImprovementCost`),
                },
            ],
        },
    ];
};

export const costSiteImprovementTableThreeMapping = (data: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.cost.costApproachData.siteImprovementComputationData.summary`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Physical depreciation %",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.physicalDepreciation`),
                },
                {
                    header: "Functional depreciation %",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.functionalDepreciation`),
                },
                {
                    header: "Economic obsolescence %",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.economicObsolescence`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Physical depreciation amount",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.physicalDepreciationAmount`),
                },
                {
                    header: "Functional depreciation amount",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.functionalDepreciationAmount`),
                },
                {
                    header: "Economic obsolescence amount",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.economicObsolescenceAmount`),
                },
                {
                    header: "Total depreciation",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.totalDepreciation`),
                },
                {
                    header: "Deprecated cost",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.depreciatedCost`),
                },
            ],
        },
    ];
};

export const incomeExpenseProFormaTableOneMapping = (data: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.income.summary`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Total Net Operating Income",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.totalNetOperatingIncome`),
                },
                {
                    header: "Capitalization rate",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, `${keyPrefix}.capitalizationRate`),
                },
                {
                    header: "Unloaded cap",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.unloadedCap`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Indicated Value",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.indicatedValue`),
                },
                {
                    header: "Add excess buildable land value",
                    editable: true,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.addExcessBuildableLandValue`),
                },
                {
                    header: "Add other",
                    editable: true,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.addOther`),
                },
                {
                    header: "Indicated Total Value",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.indicatedTotalValue`),
                },
            ],
        },
    ];
};

export const incomeExpenseProFormaTableTwoMapping = (data: any, spaceId: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.income.spaces.${spaceId}.incomeExpenseProForma.operatingIncome`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Space type",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, `${keyPrefix}.spaceType`),
                },
                {
                    header: "Unit of revenue",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, `${keyPrefix}.unitOfRevenue`),
                },
                {
                    header: "Rate",
                    editable: false,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.rate`),
                },
                {
                    header: "Size (sqft)",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, `${keyPrefix}.size`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Potential gross income",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.potentialGrossIncome`),
                },
                {
                    header: "Less market vacancy",
                    editable: false,
                    type: "text",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.lessMarketVacancy`),
                },
                {
                    header: "Less credit loss/concessions",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.lessCreditLossConcessions`),
                },
                {
                    header: "Less loss to lease",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.lessLossToLease`),
                },
                {
                    header: "Scheduled gross income",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.scheduledGrossIncome`),
                },
            ],
        },
    ];
};

export const incomeExpenseProFormaTableThreeMapping = (data: any, spaceId: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.income.spaces.${spaceId}.incomeExpenseProForma.operatingIncome`;

    return [
        {
            title: "",
            options: [
                {
                    header: "CAM Recovery",
                    editable: true,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.camRecovery`),
                },
                {
                    header: "Utility reimbursement income",
                    editable: true,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.utilityReimbursementIncome`),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Miscellaneous/other income",
                    editable: true,
                    type: "inputNumber",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.miscellaneousOtherIncome`),
                },
                {
                    header: "Total other income",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.totalOtherIncome`),
                },
                {
                    header: "Effective gross income",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.effectiveGrossIncome`),
                },
            ],
        },
    ];
};

export const incomeExpenseProFormaTableFourMapping = (data: any, spaceId: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.income.spaces.${spaceId}.incomeExpenseProForma.fixedExpenses`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Real estate taxes (In OAR)",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.realEstateTaxes`),
                },
                {
                    header: "Insurance",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.insurance`),
                },
                {
                    header: "",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, ``),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Professional management",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.professionalManagement`),
                },
                {
                    header: "Of-site staffing",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.onSiteStaffing`),
                },
                {
                    header: "Maintenance staffing",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.maintenanceStaffing`),
                },
                {
                    header: "Subtotal",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.subtotal`),
                },
            ],
        },
    ];
};

export const incomeExpenseProFormaTableFiveMapping = (data: any, spaceId: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.income.spaces.${spaceId}.incomeExpenseProForma.variableExpenses`;

    return [
        {
            title: "",
            options: [
                {
                    header: "Parking",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.parking`),
                },
                {
                    header: "Cleaning",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.cleaning`),
                },
                {
                    header: "Repairs and maintenance",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.repairsAndMaintenance`),
                },
                {
                    header: "Elevator",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.elevator`),
                },
                {
                    header: "",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, ``),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Utilities",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.utilities`),
                },
                {
                    header: "Security, grounds",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.lessCreditLossConcessions`),
                },
                {
                    header: "Administration & management",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.administrationAndManagement`),
                },
                {
                    header: "CAM expenses",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.camExpenses`),
                },
                {
                    header: "Other",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.other`),
                },
                {
                    header: "Subtotal",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.subtotal`),
                },
            ],
        },
    ];
};

export const incomeExpenseProFormaTableSixMapping = (data: any, spaceId: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.income.spaces.${spaceId}.incomeExpenseProForma`;

    return [
        {
            title: "",
            options: [],
        },
        {
            title: "",
            options: [
                {
                    header: "Total operating expenses",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.totalOperatingExpenses`),
                },
            ],
        },
    ];
};

export const incomeExpenseProFormaTableSevenMapping = (data: any, spaceId: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.income.spaces.${spaceId}.incomeExpenseProForma.capitalExpenditure`;

    return [
        {
            title: "",
            options: [
                {
                    header: "",
                    editable: false,
                    type: "text",
                    ...generateKeyValuePair(data, ``),
                },
            ],
        },
        {
            title: "",
            options: [
                {
                    header: "Replacement reserves",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.replacementReserves`),
                },
                {
                    header: "Subtotal",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.subtotal`),
                },
            ],
        },
    ];
};

export const incomeExpenseProFormaTableEightMapping = (data: any, spaceId: any) => {
    const keyPrefix = `appealDetails.appealApproachCalculationData.income.spaces.${spaceId}.incomeExpenseProForma`;

    return [
        {
            title: "",
            options: [],
        },
        {
            title: "",
            options: [
                {
                    header: "Total expense load",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.totalExpenseLoad`),
                },
                {
                    header: "Net operating income",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.netOperatingIncome`),
                },
                {
                    header: "Unloaded Cap",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.unloadedCap`),
                },
                {
                    header: "ETR",
                    headerType: "h100",
                    valueType: "h100",
                    editable: true,
                    type: "inputNumber",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.etr`),
                },
                {
                    header: "OAR",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    suffix: "%",
                    ...generateKeyValuePair(data, `${keyPrefix}.oar`),
                },
                {
                    header: "Indicated Value",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.indicatedValue`),
                },
                {
                    header: "Adjusted Value",
                    headerType: "h100",
                    valueType: "h100",
                    editable: false,
                    type: "text",
                    prefix: "$",
                    ...generateKeyValuePair(data, `${keyPrefix}.adjustedValue`),
                },
            ],
        },
    ];
};
